import React from 'react';
import TagOverViewGraphs from '../../components/TagOverViewGraphs'
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
const R = require('ramda');

class TagOverview extends React.Component {

  state = {
    barchartData: [],
    atlDistribution: [],
    atlcategoryList: [],
    learningOutcomes: null
  }

  componentDidUpdate = (prevProps) => {

    if (prevProps.projects !== this.props.projects || prevProps.atl_category !== this.props.atl_category || prevProps.learningOutcomes !== this.props.learningOutcomes) {

      const { projects, atl_category } = this.props

      let inquirersReflection = 0
      let knowledgeableReflection = 0
      let thinkersReflection = 0
      let communicatorsReflection = 0
      let principledReflection = 0
      let openMindedReflection = 0
      let caringReflection = 0
      let riskTakersReflection = 0
      let balancedReflection = 0
      let reflectiveReflection = 0
      let othersReflection = 0



      let inquirersInvestigation = 0
      let knowledgeableInvestigation = 0
      let thinkersInvestigation = 0
      let communicatorsInvestigation = 0
      let principledInvestigation = 0
      let openMindedInvestigation = 0
      let caringInvestigation = 0
      let riskTakersInvestigation = 0
      let balancedInvestigation = 0
      let reflectiveInvestigation = 0
      let othersInvestigation = 0

      let atlDistributionObj = {
        'Research': 0,
        'Thinking': 0,
        'Self-Management': 0,
        'Social': 0,
        'Communication': 0
      }
      let learningOutcomes = {}

      if (projects) {
        for (let key in projects) {
          if (projects.hasOwnProperty(key)) {
            for (let insideKey in projects[key]) {
              if (projects[key].hasOwnProperty(insideKey)) {
                let currentProject = projects[key][insideKey]

                if (currentProject && currentProject.Reflection) {
                  let learnerProfileAttribute = currentProject.Reflection.learnerProfileAttribute
                  let ATLCategories_Reflection = currentProject.Reflection.ATLCategories || []
                  let ATLCategories_Investigation = currentProject.Investigation.ATLCategories || []
                  let ATLCategories = ATLCategories_Reflection.concat(ATLCategories_Investigation)

                  let learningOutcomesReflection = currentProject.Reflection.learningOutcomes || []
                  let learningOutcomesInvestigation = currentProject.Investigation.relevantServiceLearningOutcomes || []
                  let currentLearningOutcomes = learningOutcomesReflection.concat(learningOutcomesInvestigation)
                  console.log('currentLearningOutcomes', currentLearningOutcomes);

                  learnerProfileAttribute && learnerProfileAttribute.forEach(element => {
                    switch (element) {
                      case 'Inquirers':
                        inquirersReflection++
                        break;
                      case 'Knowledgeable':
                        knowledgeableReflection++
                        break;
                      case 'Thinkers':
                        thinkersReflection++
                        break;
                      case 'Communicators':
                        communicatorsReflection++
                        break;
                      case 'Principled':
                        principledReflection++
                        break;
                      case 'Open-Minded':
                        openMindedReflection++
                        break;
                      case 'Caring':
                        caringReflection++
                        break;
                      case 'Risk-Takers':
                        riskTakersReflection++
                        break;
                      case 'Balanced':
                        balancedReflection++
                        break;
                      case 'Reflective':
                        reflectiveReflection++
                        break;
                      default:
                        othersReflection++
                        break;
                    }
                  });

                  ATLCategories.map( item => {
                    atlDistributionObj[item] = atlDistributionObj[item] + 1
                  })

                  currentLearningOutcomes.map( item => {
                    if (learningOutcomes[item] && outcomes.includes(item)) {
                      learningOutcomes[item].count = learningOutcomes[item].count +1
                    } else if ( outcomes.includes(item) ){
                      learningOutcomes[item] = {
                        name: item,
                        count: 1
                      }
                    }
                  })

                }


                if (currentProject && currentProject.Investigation) {
                  let learnerProfileAttributeInvestigation = currentProject.Investigation.learnerProfileAttribute
                  learnerProfileAttributeInvestigation && learnerProfileAttributeInvestigation.forEach(element => {
                    switch (element) {
                      case 'Inquirers':
                        inquirersInvestigation++
                        break;
                      case 'Knowledgeable':
                        knowledgeableInvestigation++
                        break;
                      case 'Thinkers':
                        thinkersInvestigation++
                        break;
                      case 'Communicators':
                        communicatorsInvestigation++
                        break;
                      case 'Principled':
                        principledInvestigation++
                        break;
                      case 'Open-Minded':
                        openMindedInvestigation++
                        break;
                      case 'Caring':
                        caringInvestigation++
                        break;
                      case 'Risk-Takers':
                        riskTakersInvestigation++
                        break;
                      case 'Balanced':
                        balancedInvestigation++
                        break;
                      case 'Reflective':
                        reflectiveInvestigation++
                        break;
                      default:
                        othersInvestigation++
                        break;
                    }
                  });
                }
              }
            }
          }
        }
      }

      const barchartData = [
        { name: 'Inquirers', Investigation: inquirersInvestigation, Reflection: inquirersReflection },
        { name: 'Knowledgeable', Investigation: knowledgeableInvestigation, Reflection: knowledgeableReflection },
        { name: 'Thinkers', Investigation: thinkersInvestigation, Reflection: thinkersReflection },
        { name: 'Communicators', Investigation: communicatorsInvestigation, Reflection: communicatorsReflection },
        { name: 'Principled', Investigation: principledInvestigation, Reflection: principledReflection },
        { name: 'Open-Minded', Investigation: openMindedInvestigation, Reflection: openMindedReflection },
        { name: 'Caring', Investigation: caringInvestigation, Reflection: caringReflection },
        { name: 'Risk-Takers', Investigation: riskTakersInvestigation, Reflection: riskTakersReflection },
        { name: 'Balanced', Investigation: balancedInvestigation, Reflection: balancedReflection },
        { name: 'Reflective', Investigation: reflectiveInvestigation, Reflection: reflectiveReflection }
      ]

      let atlDistribution = [
        {name: 'Research', value: atlDistributionObj['Research']},
        {name:'Thinking', value: atlDistributionObj['Thinking']},
        {name:'Self-Management', value: atlDistributionObj['Self-Management']},
        {name:'Social', value: atlDistributionObj['Social']},
        {name:'Communication', value: atlDistributionObj['Communication']}
      ]
      let atlcategoryList = []

      let cntArray = atl_category && Object.values(atl_category).map(item => item.count || 1)
      // console.log('cntArray', cntArray)
      const total = cntArray && R.sum(cntArray);
      //console.log('total', total)
      atl_category && Object.values(atl_category).map((item) => {
        item.value = ((item.count || 0) * 100) / total
        //atlDistribution.push(item)
        atlcategoryList.push(item.name)
      });

      //console.log('atlDistribution', atlDistribution)
      //console.log('atlcategoryList', atlcategoryList)

      this.setState({
        barchartData,
        learningOutcomes,
        atlDistribution,
        atlcategoryList
      })
    }
  }

  render() {

    const { barchartData, atlDistribution, atlcategoryList, learningOutcomes } = this.state

    if (barchartData) {
      return (
        <TagOverViewGraphs
          barchartData={barchartData}
          distribution={atlDistribution}
          t={this.props.t}
          categoryList={atlcategoryList}
          learningOutcomes={learningOutcomes}
        />
      )
    }
    else {
      return (<div>Loading</div>)
    }

  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect((props) => {
    return [
      'users', 'projects', 'atl_category', 'learningOutcomes'
    ]
  }),
  connect(
    state => {

      const users = state.firebase.data.users
      const projects = state.firebase.data.projects
      let teacherSchoolId = state.firebase && state.firebase.profile.profile.school.id
      const selectedUsers = users && Object.entries(users)
        .filter(inv => inv[1].profile.school && inv[1].profile.school.id === teacherSchoolId)
        .map(inv => inv[0])

      let filteredData = {};
      projects && Object.entries(projects).filter(item => selectedUsers.indexOf(item[0]) >= 0).forEach(item => { filteredData[item[0]] = item[1] });

      return {
        users: state.firebase.data.users,
        projects: filteredData,
        atl_category: state.firebase.data.atl_category,
        learningOutcomes: state.firebase.data.learningOutcomes

      }
    }
  )
)

export default enhancer(TagOverview);

let outcomes = ['become more aware of their own strengths and areas for growth',' undertake challenges that develop new skills', 'discuss, evaluate and plan student-initiated activities', 'persevere in action', 'work collaboratively with others', 'develop international-mindedness through global engagement, multilingualism and intercultural understanding', 'consider the ethical implications of their actions']



// WEBPACK FOOTER //
// ./src/containers/TagOverview/index.jsx